export default __webpack_public_path__ + "static/media/icon-arrow-grey.8654fccd.svg";